<template>
  <div class="chat-list">
    <div class="header">
      <input placeholder="Search Chats..." class="search">
      <router-link to="/chats/new" class="link-simple">New</router-link>
    </div>
    <div class="body">
      <item v-for="(chat, id) in chats" :key="chat['.key']" :after="chat.showAfter" :id="chat['.key']"></item>
    </div>
  </div>
</template>

<script>
import Item from '@/components/chat/list/Item'
var moment = require('moment')

export default {
  name: 'List',
  props: ['chats'],
  data () {
    return {
      moment: moment
    }
  },
  components: {
    Item
  }
}
</script>



// WEBPACK FOOTER //
// List.vue?27104016